import { Injectable } from '@angular/core';
import { PrintEpsonService } from './print-epson.service';
import { BehaviorSubject } from 'rxjs';
import { OrderService } from 'src/app/appServices/order.service';
import { IOrderModel } from 'src/app/appModels/IOrderModel';
import { LogService } from 'src/app/appServices/log.service';
import { StorageService } from 'src/app/appServices/storage.service';
import { StorageKeys } from 'src/app/appServices/storage-keys';

declare global {
  interface Window {
    AndroidPrinter?: any;
    onPrintResult?: (status: string) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class ReceiptPrinterService {

  orderDetails: any;

  private globalPrinterLogsSource = new BehaviorSubject<string>('');
  globalPrinterLogs$ = this.globalPrinterLogsSource.asObservable();


  constructor(
    private printEpsonService: PrintEpsonService,
    private orderService: OrderService,
    private logService: LogService,
    private storageService: StorageService
  ) {
  }

  // In your Angular service

  /**
   * Update global printer logs
   * @param logs
   */
  updateGlobalPrinterLogs(logs: string) {
    this.globalPrinterLogsSource.next(logs);
  }





  /**
   * Print Reciept
   * @param orderId
   * @param change
   */
  printStuff(orderId: number, change?: any, autoPrint?: boolean) {
    this.getOrderDetailsAndPrint(orderId, change, autoPrint);
  }

  /**
 * Print Reciept
 * @param orderId
 * @param change
 */
  printOrder(order: IOrderModel, change?: any, autoPrint?: boolean) {
    this.orderDetails = order;
    this.orderDetails.change = change;
    if (autoPrint) {
      this.getAllAutoPrinters();
    } else {
      this.getAllPrinters();
    }
  }



  /**
   * Get order details & print
   * @param orderId
   * @param change
   */
  getOrderDetailsAndPrint(orderId: number, change?: any, autoPrint?: boolean) {
    this.orderService.getOrderById(orderId).subscribe(
      async (res) => {
        this.orderDetails = res;
        console.log('orderDetails: ', this.orderDetails);
        this.orderDetails.change = change;
        if (autoPrint) {
          await this.getAllAutoPrinters();
        } else {
          await this.getAllPrinters();
        }
      },
      (error) => {
        console.error('Error fetching order details', error);
      }
    );
  }


  /**
   * Get all printers
   */

  async getAllAutoPrinters() {
    const printerList = await this.storageService.getItem<any[]>(StorageKeys.PRINTERS) || [];
    const autoPrinterList = printerList.filter((printer: any) => printer.autoPrint === true);
    console.log('Auto printers:', autoPrinterList);
    console.log('Auto printer initiated:');
    this.printOnConnectedPrinters(autoPrinterList);
  }

  /**
   * Get all printers
   */
  async getAllPrinters() {
    const printerList = await this.storageService.getItem<any[]>(StorageKeys.PRINTERS) || [];
    this.printOnConnectedPrinters(printerList);
  }

  /**
   * Print on connected printers
   * @param printerList
   */
  printOnConnectedPrinters(printerList: any[]) {
    for (const printer of printerList) {
      if (printer.connected) {
        this.printCommon(printer);
      }
    }
  }



  /**
   * Print on ConnectionType
   * @param printer
   */
  printCommon(printer: any) {
    this.epsonIpPrint(printer);
  }


  /**
   * Epson Ip Print
   * @param printer
   */
  epsonIpPrint(printer: any) {
    if (window.AndroidPrinter) {
      // Never fall through to the dummy test ticket from an order-print path:
      // reaching here without an order means a caller forgot to set one.
      if (!this.orderDetails) {
        console.error('epsonIpPrint called without an active order; skipping print on', printer?.ip);
        return;
      }
      this.printEpsonService.androidPrint(printer.connectionType, printer.ip, printer.brand, this.orderDetails);
      window.onPrintResult = (message: string) => {

        const isSuccess = !message.startsWith('Error');
        if (!isSuccess) {
          const payload = {
            message,
            device: printer.brand,
            ip: printer.ip,
            conntectinType: printer.connectionType
          }
          this.saveErrorLogs(payload);
        }


      };
    } else {
      this.printEpsonService.print(this.orderDetails);
    }
  }




  /**
 * Save error logs
 * @param message 
 */
  saveErrorLogs(message: any) {
    message.channel = 'Kiosk';
    const payload = {
      type: 'PRINTER',
      logs: message
    }
    this.logService.saveLogs(payload).subscribe({
      next: (res) => { },
      error: (err) => { }
    });
  }
}
